import { RemoveActionContext } from "./RemoveActionContext";
import usePrepareRemove from "./usePrepareRemove";
import useRemove from "./useRemove";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";

function useRemoveAction(index: any): any {
  const prepareRemove = usePrepareRemove();
  const prepareRemoveFunction = (id: any) => prepareRemove(id);

  const onSuccessRemove = () => {
    setShowModal(false);
    index();
  };
  
  const remove = useRemove();  

  const removeFunction = () => remove(onSuccessRemove);

  const contextInstance = useContext(RemoveActionContext);
  const { setShowModal } = contextInstance;
  
  const modalConfig = {
    contextInstance: contextInstance,
    title: "remove_delivery_note",
    onSubmit: () => removeFunction(),

  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>      
      <p>{t('are_you_shure_you_want_to_delete_this_delivery_note?')}</p>      
    </CrudModuleFactoryModal>
  );

  return {
    prepareRemoveFunction,
    actionTemplate,
  };
}

export default useRemoveAction;
